import { useMemo } from 'react';

import {
  AttributeRenderer as CommonAttributeRenderer,
  type StoreValues,
} from '@/features/c-form/AttributeRenderer';
import { toRendererAttributes } from '@/features/section-attribute';

import type { DeviceDetailAttribute } from './-query';

const NOOP_UPDATE = () => {};
const EMPTY_STORE: StoreValues = { sections: [] };

interface Props {
  attributes: DeviceDetailAttribute[];
  sectionKey: string;
}

/**
 * 読み取り専用の属性レンダラー
 *
 * DeviceDetailFormStore に依存せず、属性値をそのまま表示する。
 * lifecycle / status タブなど readonly タブで使用。
 */
export function ReadonlyAttributeRenderer({ attributes, sectionKey }: Props) {
  const memoizedAttributes = useMemo(
    () =>
      toRendererAttributes(
        attributes.map((attr) => ({
          ...attr,
          name: attr.name ?? attr.attributeKey,
        })),
      ),
    [attributes],
  );

  return (
    <CommonAttributeRenderer
      attributes={memoizedAttributes}
      sectionKey={sectionKey}
      updateSectionAttribute={NOOP_UPDATE}
      storeValues={EMPTY_STORE}
    />
  );
}
